"use client";
import React, { FC } from "react";
import Image from "next/image";
import Link from "next/link";
import { projectsData } from "../../../lib/fackData/projectsData";

function chunkArray<T>(array: T[], size: number): T[][] {
  const chunkedArr: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunkedArr.push(array.slice(i, i + size));
  }
  return chunkedArr;
}

const ProjectsOverview: FC = () => {
  const projects = projectsData.slice(0, 6); // Nur die ersten 6 Projekte
  const chunkSize = 2;
  const chunkedData = chunkArray(projects, chunkSize);

  return (
    <div className="mx-auto max-w-screen-xl px-4 py-4">
      <div className="mb-12 text-center">
        <h1 className="text-4xl font-bold text-company-color-primary mb-4">Unsere Projekte</h1>
        <p className="text-xl text-gray-600">Entdecken Sie unsere erfolgreich umgesetzten Projekte</p>
      </div>
      
      {chunkedData.map((row, rowIndex) => (
        <div className="flex flex-wrap -mx-2 mt-6" key={rowIndex}>
          {row.map((project, colIndex) => (
            <div className="w-full md:w-1/2 px-2 mb-4" key={colIndex}>
              <div className="bg-white shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full">
                <div className="relative h-[400px] overflow-hidden">
                  <Image
                    src={project.project_img}
                    alt={project.project_name}
                    fill
                    className="object-cover"
                    priority={rowIndex === 0 && colIndex === 0}
                  />
                </div>
                <div className="p-6 bg-white flex flex-col flex-grow">
                  <h3 className="text-2xl font-bold text-company-color-primary mb-2">
                    {project.project_name}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-4 min-h-[6rem]">
                    {project.project_desc}
                  </p>
                  <div className="flex flex-wrap gap-4 mb-4 text-sm text-gray-500">
                    <span><strong>Jahr:</strong> {project.project_year}</span>
                    <span><strong>Typ:</strong> {project.project_type}</span>
                    <span><strong>Standort:</strong> {project.location}</span>
                  </div>
                  <Link
                    href={project.link}
                    className="inline-block mt-auto px-6 py-2 bg-company-color-primary text-white font-semibold rounded hover:bg-opacity-90 transition-colors duration-200"
                  >
                    Mehr erfahren
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ProjectsOverview;

